import { MediaLibraryPage, buildProcessHandler, useGetByDevice } from '@onesource/components';
import { EImageVariant } from '@onesource/schemas';
import { Helmet } from 'react-helmet-async';

// Members upload the file as-is — matching the previous behaviour of this page. The bytes
// that land in R2 are what the monthly personal quota is charged for (MediaService.create).
const UPLOAD_VARIANTS = [EImageVariant.original];
const processHandler = buildProcessHandler(UPLOAD_VARIANTS);

export function MediaPage() {
  const { isMobile } = useGetByDevice();

  return (
    <>
      <Helmet>
        <title>Media Library</title>
        <meta name="description" content="Manage your uploaded media files" />
      </Helmet>
      <MediaLibraryPage
        processHandler={processHandler}
        imageVariants={UPLOAD_VARIANTS}
        title={isMobile ? 'Media' : 'Media Library'}
        viewPrefKey="lc-media-view"
      />
    </>
  );
}
